module.exports = __webpack_public_path__ + "static/media/dashboard.c45a076e.png";